const navigate = (htmlId: string): void => document.getElementById(htmlId)?.scrollIntoView({ behavior: 'smooth' });

const domNavigationHelper = { navigate };

export default domNavigationHelper;
